// extracted by mini-css-extract-plugin
export default {"formHeading":"HJ-z","form":"IJ-z","submitBtn":"JJ-z","disabled":"KJ-z","input":"LJ-z","error":"MJ-z","submitMsg":"NJ-z","signIn":"OJ-z"};